import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImageComponent } from './image.component';
import { SpinnerModule } from '@pc-ui/spinner';

@NgModule({
  declarations: [ImageComponent],
  imports: [CommonModule, SpinnerModule],
  exports: [ImageComponent],
})
export class ImageModule {}
